import { IBrand, MachineType } from '../../../interfaces/Brand.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface IGetBrandsParams {
  searchParam: {
    applicableMachineType: MachineType | '';
  };
}

export const getBrands = ({ searchParam }: IGetBrandsParams): Promise<IBrand[]> => {
  const URLSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/brands?${URLSearchParams}`);
};
